import * as React from 'react'
import 'react-dates/initialize'
import styled from 'styled-components'
import I18n from '../../../core/i18n'
import * as constants from '../../../static/constants'
import * as interfaces from '../../../static/interfaces'
import { AboutReservation } from '../reservations/parts'
import Typography from 'components/atoms/_layouts/Typography'
import { Button, Panel } from 'components/atoms'
import SvgIcon from 'components/atoms/SvgIcon'
declare var window: interfaces.IWindow

import SidebarLayout from './sidebarLayout'

interface IProps {
  user: any
  reservation?: interfaces.IMessageReservation
  tour?: any
  receipt_id: number | null
  host?: any
  pageName: 'check_reservation' | 'check_tour' | 'assign_guide'
  Side: React.ReactNode
  Main: React.ReactNode
  setReservation?(reservation: any): void
}

const MessageLayout: React.VFC<IProps> = ({
  user,
  host,
  reservation,
  tour,
  receipt_id,
  pageName,
  Main,
  Side,
  setReservation,
}) => {
  const showAboutReservationModal = () => {
    if (!reservation) {
      return
    }
    window.globalModal.showModal({
      body: (
        <AboutReservation
          reservation={reservation}
          receiptId={receipt_id}
          user={user}
          setReservation={setReservation}
          isAgentCreatePost={host?.agent || false}
          page="check_reservation"
        />
      ),
      closeText: I18n.t('generic.cancel'),
    })
  }

  const pageTitle = React.useMemo(() => {
    if (pageName === 'check_reservation' && host?.agent) {
      return I18n.t('reservation.check_tour')
    }
    if (pageName === 'check_tour') {
      return I18n.t('reservation.check_tour')
    }
    if (pageName === 'assign_guide') {
      return I18n.t('reservation.assign_guide')
    }
  }, [pageName])

  return (
    <SidebarLayout user={user}>
      <Panel noDecoration={user.guest ? true : false}>
        <Conversation>
          <div className="Conversation_Header">
            {!user.admin && (
              <a href="#" onClick={() => window.history.go(-1)}>
                <SvgIcon
                  name="keyboard_arrow_left"
                  className="icon"
                  ariaHidden={true}
                  role="presentation"
                />
                <span>{I18n.t('reservation.back_to_index')}</span>
              </a>
            )}
            {pageTitle && <Typography type="headline">{pageTitle}</Typography>}
            <div className="Conversation_Title">
              <Typography type="headline" size="sm">
                {reservation?.post?.name || tour?.post?.name}
              </Typography>
            </div>
            {reservation && (
              <div className="Reservation_Detail_Section">
                <div>
                  <Button small={true} handleClick={showAboutReservationModal}>
                    {I18n.t('reservation.reservation_detail')}
                  </Button>
                </div>

                <div className="Reservation_No">
                  Reservation no:{' '}
                  <Typography type="subtitle" size="lg">
                    {reservation?.no}
                  </Typography>
                </div>
              </div>
            )}
          </div>
          <div className="Conversation_Main">
            <div className="Conversation_Left">{Side}</div>
            <div className="Conversation_Right">
              <div className="Conversation_Separator">
                <span>{I18n.t('generic.message')}</span>
              </div>
              {Main}
            </div>
          </div>
        </Conversation>
      </Panel>
    </SidebarLayout>
  )
}
const Conversation = styled.div`
  max-width: 1088px;
  margin: 24px auto;
  padding: 0 24px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    padding: 16px 12px;
  }

  .Conversation_Header {
    padding: 12px 0;

    > a {
      display: flex;
      align-items: center;
      color: ${constants.COLORS.primary};
      font-size: 14px;
      margin-bottom: 16px;
    }
    .Conversation_Title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 16px 0;
    }
    .Reservation_Detail_Section {
      display: flex;
      flex-direction: column;
      align-items: end;
      gap: 8px;
      .Reservation_No {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
  }

  .Conversation_Main {
    display: flex;
    gap: 32px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      display: block;
    }
    .Conversation_Left {
      max-width: 240px;
      width: 100%;
      flex-shrink: 1;
      > div {
        margin-top: 0;
      }
      > h4 {
        font-size: 1.2em;
      }
      @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
        max-width: 100%;
      }
    }
    .Conversation_Right {
      flex: 1;
    }
  }

  .Conversation_Separator {
    position: relative;
    display: none;
    margin: 28px 0;
    border-top: solid 1px ${constants.COLORS.divider};
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      display: block;
    }

    > span {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: auto;
      padding: 0 16px;
      display: inline-block;
      background-color: ${constants.COLORS.white};
      color: ${constants.COLORS.subText};
      font-weight: bold;
    }
  }
`

export default MessageLayout
